"use client";
import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footersection";

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex flex-col items-center flex-1 p-10 w-full max-w-5xl mx-auto gap-8">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Shipping Policy
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 w-full space-y-6 text-gray-700 text-lg">
          <section>
            <p>Thank you for shopping with One Stop Wedding Dresses. This Shipping Policy describes how we deliver orders placed on our website.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">1. Shipping Locations</h2>
            <ul>
  <li>We currently ship to [India-wide, selected cities, and specific countries].</li>
  <li>For international orders, please contact us before placing an order.</li>
</ul>
 </section>

          <section>
            <h2 className="font-semibold mb-2">2. Processing Time</h2>
            <p>Orders are usually processed within 2 working days after payment confirmation. During festivals, sales, or high volume periods, processing time may be slightly longer.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">3. Delivery Time</h2>
            <p>
              Within India: Estimated delivery time is 7 working days after dispatch.<br />
              International Shipping: Estimated delivery time is 10 days depending on the country and customs.<br />
              <span className="italic text-sm">Note: These are estimated timelines; delays may occur due to courier issues, weather, holidays, or other factors beyond our control.</span>
            </p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">4. Shipping Charges</h2>
            <p>Shipping charges are calculated at checkout based on order value, weight, and delivery location. We may offer free shipping above a certain order value, as mentioned on the website from time to time.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">5. Order Tracking</h2>
            <p>Once your order is dispatched, you will receive a tracking ID/link via email/SMS/WhatsApp. You can track your order status online through the courier partner’s website.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">6. Wrong / Incomplete Address</h2>
            <p>Please ensure your address, PIN code, and phone number are correct at the time of placing the order. If a package is returned due to an incorrect or incomplete address, re-shipping charges may apply.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">7. Delays & Force Majeure</h2>
            <p>We are not responsible for delays caused by circumstances beyond our control, such as:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Natural disasters, lockdowns, strikes, political unrest</li>
              <li>Courier partner delays</li>
            </ul>
            <p>In such cases, we will do our best to assist you and keep you updated.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">8. International Customs & Duties</h2>
            <p>For international orders, customs duties, taxes, and other charges (if any) are payable by the customer as per the destination country’s laws.</p>
          </section>

          <section>
            <h2 className="font-semibold mb-2">Contact Us</h2>
            <p>
              Email: <a href="mailto:support@onestopweddingdresses.com" className="text-blue-600 hover:underline">support@onestopweddingdresses.com</a><br />
              Phone/WhatsApp: <a href="tel:+918333922444" className="text-blue-600 hover:underline">+91 83339 22444</a>
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ShippingPolicy;
